/**
 * Single source of truth for partner tier from classifications.
 *
 * - Strategic = 3 or more focus areas
 * - Active = 2 focus areas
 * - Engaged = 1 focus area
 * - Shelved = classifications contains "Shelved (to be upgraded or discontinued)"
 *
 * Focus area count excludes the shelved classification.
 * Returns null when classifications is null, blank, or empty.
 */

export const TIER_STRATEGIC = "Strategic";
export const TIER_ACTIVE = "Active";
export const TIER_ENGAGED = "Engaged";
export const TIER_SHELVED = "Shelved";

export const CLASSIFICATION_SHELVED = "Shelved (to be upgraded or discontinued)";

export const FOCUS_AREAS = [
  "Employment-focused",
  "Training-focused",
  "Research-focused",
  "Sponsorship-focused",
  "Project-focused",
  "General partnership",
];

export const TIER_DISPLAY_ORDER = [
  TIER_STRATEGIC,
  TIER_ACTIVE,
  TIER_ENGAGED,
  TIER_SHELVED,
];

function normalizeClassifications(classifications) {
  if (!classifications || !Array.isArray(classifications) || classifications.length === 0) {
    return null;
  }

  var normalized = [];
  for (var i = 0; i < classifications.length; i++) {
    var label = classifications[i];
    if (typeof label === "string") {
      label = label.trim();
      if (label !== "") {
        normalized.push(label);
      }
    }
  }

  if (normalized.length === 0) {
    return null;
  }

  return normalized;
}

export function countFocusAreas(classifications) {
  var labels = normalizeClassifications(classifications);
  if (!labels) {
    return 0;
  }

  var count = 0;
  for (var i = 0; i < labels.length; i++) {
    var label = labels[i];
    if (label === CLASSIFICATION_SHELVED) {
      continue;
    }
    if (FOCUS_AREAS.indexOf(label) !== -1) {
      count++;
    }
  }

  return count;
}

export function evaluatePartnerTier(partner) {
  if (!partner) {
    return null;
  }

  var classifications = normalizeClassifications(partner.classifications);
  if (!classifications) {
    return null;
  }

  if (classifications.indexOf(CLASSIFICATION_SHELVED) !== -1) {
    return TIER_SHELVED;
  }

  var focusCount = countFocusAreas(classifications);

  if (focusCount >= 3) {
    return TIER_STRATEGIC;
  }

  if (focusCount === 2) {
    return TIER_ACTIVE;
  }

  if (focusCount === 1) {
    return TIER_ENGAGED;
  }

  return null;
}

export function getPartnerTierLabel(partner) {
  var tier = evaluatePartnerTier(partner);
  return tier || "";
}

export function getTierBadgeClass(tier) {
  if (tier === TIER_STRATEGIC) {
    return "partner-tier-badge partner-tier-badge-strategic";
  }
  if (tier === TIER_ACTIVE) {
    return "partner-tier-badge partner-tier-badge-active";
  }
  if (tier === TIER_ENGAGED) {
    return "partner-tier-badge partner-tier-badge-engaged";
  }
  if (tier === TIER_SHELVED) {
    return "partner-tier-badge partner-tier-badge-shelved";
  }
  return "";
}
